import { UserManagerSettings, WebStorageStateStore } from 'oidc-client-ts';
import { EasyEnvironment } from '@easy-lib/modules/shared/models/environment';

export const getClientSettings = (environment: EasyEnvironment): UserManagerSettings => {
	const settings = {
		authority: environment.oidcSettings.authority,
		client_id: environment.oidcSettings.client_id,
		redirect_uri: environment.oidcSettings.redirect_uri,
		post_logout_redirect_uri: environment.oidcSettings.post_logout_redirect_uri,
		response_type: environment.oidcSettings.response_type,
		scope: environment.oidcSettings.scope,
		loadUserInfo: environment.oidcSettings.loadUserInfo,
		automaticSilentRenew: true,
		// silent_redirect_uri: environment.oidcSettings.silent_redirect_uri,
		monitorSession: false,
		userStore: new WebStorageStateStore({ store: window.sessionStorage })
	} as UserManagerSettings;

	return settings;
};
